<template>
	<el-container>
		<commonHeader></commonHeader>
		<el-main>
			<el-col :span="6" :offset="5">
				<el-image :src="url2" fit="fill"></el-image>
			</el-col>
			<el-col :span="5" :offset="2" style="margin-top: 40px;">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>登录</span>
					</div>

					<el-form :model="ruleForm2" status-icon ref="ruleForm2" label-position="left" label-width="0px"
						class="demo-ruleForm login-page">
						<el-form-item prop="mobile">
							<el-input size="medium" placeholder="请输入手机号" v-model="ruleForm2.mobile">
								<template slot="prepend"><i class="el-icon-user"></i></template>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input size="medium" show-password placeholder="请输入密码" v-model="ruleForm2.password">
								<template slot="prepend"><i class="el-icon-lock"></i></template>
							</el-input>
						</el-form-item>
					</el-form>
					<p style="font-size: 14px;color:#999;">
						<!-- <span @click="forgot" style="cursor: pointer;">忘记密码？</span> -->
					</p>
					<el-col :span="24" style="text-align: center;margin-top: 20px;margin-bottom: 30px;">
						<el-button :loading="this.$store.state.ajaxLoading" style="width: 80%;" type="primary" @click="handleSubmit">立即登录
						</el-button>
						<p style="font-size: 14px;color:#999">
							<!-- <span>没有账号？</span>
							<span @click="register" style="color:rgb(64, 158, 255);cursor: pointer;">注册</span> -->
						</p>
					</el-col>
				</el-card>
			</el-col>
		</el-main>
		<el-footer style="margin-top:20px;text-align: center;font-size: 14px;color:#999">
			<commonFooter></commonFooter>
		</el-footer>
	</el-container>
</template>

<script>
	import {
		login
	} from '@/api/login'
	import {
		setToken
	} from '@/tool/cookie'
	import router from '@/router'
	import Qs from 'qs'
	import commonHeader from '@/components/Jd/commonHeader';
	import commonFooter from '@/components/Jd/commonFooter';
	export default {
		components: {
			commonHeader,commonFooter
		},
		data() {
			return {
				url: '/logo.png',
				url2: '/xc.png',
				ruleForm2: {
					mobile: '',
					password: '',
				},
				checked: false
			}
		},
		methods: {
			register() {
				this.$router.push({
					path: '/register'
				})
			},
			forgot() {
				this.$router.push({
					path: '/forgot'
				})
			},
			handleSubmit(event) {
				this.$store.commit('setAjaxLoading', true);
				login(Qs.stringify(this.ruleForm2)).then(response => {
					// 存储商家的uid和token
					setToken('admin_name', response.result.user_name);
					setToken('login_uid', response.result.id);
					setToken('token', response.result.token);
					//  跳转到首页
					this.$router.push('/')

				})
			}
		}
	}
</script>

<style>
</style>
